import { render } from "./TheCardKPI.vue?vue&type=template&id=3b9a3cfb"
import script from "./TheCardKPI.vue?vue&type=script&lang=js"
export * from "./TheCardKPI.vue?vue&type=script&lang=js"

import exportComponent from "F:\\Softwaresul\\Projetos Node\\LWP\\Nil Key\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__